export const TAXONOMY_MULTISELECT_DELIMITER = ';';
export const TAXONOMY_SKIP_SEGMENT = 'all';
export const FILTER_PATH_SEPARATOR = '/-/';

// Surface segment sits in slot 2 of /shop URLs, between the route literal and
// the taxonomy hierarchy. Only `all` is supported initially; `gifts` will be
// added in a follow-up ticket.
export const SHOP_SURFACE_ALL = 'all';
export const SHOP_VALID_SURFACES: readonly string[] = [SHOP_SURFACE_ALL];
